import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet } from 'react-native';
import { ActivityIndicator, ErrorMessageRetryBackdrop } from 'trpc-react-native-ui';

const styles = StyleSheet.create({
  contentView: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const DefensiveView = props => {
  if (props.isRefreshing) {
    return props.children;
  } else if (props.isFetching) {
    return <ActivityIndicator style={styles.contentView} />;
  } else if (props.isFailure) {
    return props.fetchData ? <ErrorMessageRetryBackdrop onRetry={props.fetchData} /> : <ErrorMessageRetryBackdrop />;
  }
  return props.children;
};

DefensiveView.propTypes = {
  children: PropTypes.object.isRequired,
  fetchData: PropTypes.func,
  isFailure: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isRefreshing: PropTypes.bool,
};

export default DefensiveView;
